export default "__VITE_ASSET__BKfkpUDb__"